import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  loggedInUserInfo: {};
  constructor(private http: HttpClient, private router: Router) {}

  public validate(userName, passWord, locaTion): Observable<any> {
    return this.http.post<any>('/api/login/login', {
      username: userName,
      password: passWord,
      location: locaTion
    });
  }

  logout(userId): Observable<any> {
    return this.http.get<any>('/api/login/logout/' + userId);
  }

  getToken(): any {
    return localStorage.getItem('userToken');
  }
}
